import { render, staticRenderFns } from "./FaceValidation.vue?vue&type=template&id=bc857fc8&scoped=true&"
import script from "./FaceValidation.vue?vue&type=script&lang=ts&"
export * from "./FaceValidation.vue?vue&type=script&lang=ts&"
import style0 from "./FaceValidation.vue?vue&type=style&index=0&id=bc857fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc857fc8",
  null
  
)

export default component.exports